import React from 'react';
import {
  Box,
  Flex,
  Text,
  Divider,
  Skeleton,
  Container,
  Img,
} from '@chakra-ui/react';
import PintarIcon1 from '../../assets/svg/ic-book-ai.svg';
import PintarIcon2 from '../../assets/svg/ic-brain-sparkle.svg';
import TentangPintarImage from '../../assets/webp/about-pintar-new.webp';

const AboutPintar: React.FC = () => {
  return (
    <Box bg="white">
      <Container maxW="8xl">
        <Flex
          my={{ base: 8, md: 40 }}
          flexDirection={{ base: 'column', md: 'row' }}
          justifyContent="space-between"
        >
          <Box
            w={{ base: '100%', md: '49%' }}
            display="flex"
            justifyContent="center"
          >
            <Img
              w={{ base: '100%', md: 'auto' }}
              fallback={<Skeleton h="full" w="80%" />}
              h="auto"
              maxH="380px"
              src={TentangPintarImage}
              alt="Gambar Tentang Pintar"
              objectFit="cover"
            />
          </Box>
          <Box w={{ base: '100%', md: '49%' }}>
            <Box mb={4}>
              <Text
                fontSize={{ base: '2xl', md: '5xl' }}
                fontWeight="medium"
                mt={{ base: '1rem', md: '0rem' }}
              >
                Tentang Pintar
              </Text>
              <Text
                fontSize="md"
                mt={2}
                lineHeight="base"
                letterSpacing="wider"
              >
                Pintar (Pusat Informasi Pelatihan & Pembelajaran) hadir sebagai
                wadah untuk belajar bersama secara daring dan terbuka untuk
                semua ASN Kementerian Agama di Indonesia. PINTAR terdiri dari
                dua kategori pembelajaran yakni, pelatihan dan pengetahuan,
                semua tersedia dalam bentuk artikel, video, dan materi untuk
                meningkatkan skill dan kapasitas SDM Kementerian Agama, agar
                semua dapat tumbuh bersama.
              </Text>
            </Box>
            <Divider my={{ base: 4, md: 6 }} />
            <Flex flexDirection={['row']} justifyContent="space-between">
              <Box w={{ base: '48%', md: '50%' }} mb={[4, 0]}>
                <Box
                  w="59px"
                  h="59px"
                  display="flex"
                  borderRadius="full"
                  alignItems="center"
                  justifyContent="center"
                  style={{
                    background:
                      'linear-gradient(29.01deg, #22C55E 8.34%, #E2FF7D 94.44%)',
                  }}
                >
                  <Img src={PintarIcon1} w={6} h={6} />
                </Box>
                <Text
                  mt={2}
                  fontSize={{ base: 'sm', md: 'md' }}
                  fontWeight="semibold"
                >
                  Pusat Pelatihan & Media <br /> Pembelajaran Online
                </Text>
              </Box>
              <Box w={{ base: '48%', md: '50%' }}>
                <Box
                  w="59px"
                  h="59px"
                  display="flex"
                  borderRadius="full"
                  alignItems="center"
                  justifyContent="center"
                  style={{
                    background:
                      'linear-gradient(201.89deg, #FACC15 39.53%, #FCA118 118.17%)',
                  }}
                >
                  <Img src={PintarIcon2} w={6} h={6} />
                </Box>
                <Text
                  mt={2}
                  fontSize={{ base: 'sm', md: 'md' }}
                  fontWeight="semibold"
                >
                  Pusat Pengetahuan & <br /> Peningkatan Kualitas SDM
                </Text>
              </Box>
            </Flex>
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};

export default AboutPintar;
